export const showToast = (message: string, variant: "success" | "error" = "success") => {
  const toastElement = document.createElement("div");
  toastElement.className = "toast-fixed";
  toastElement.textContent = message;
  
  const background = variant === "success" 
    ? "linear-gradient(271.58deg, #004ef7 0%, #00eab2 96.51%)" 
    : "linear-gradient(271.58deg, #ff2d55 0%, #ff9500 96.51%)";
    
  const shadowColor = variant === "success" ? "rgba(0, 78, 247, 0.3)" : "rgba(255, 45, 85, 0.3)";

  toastElement.style.cssText = `
    position: fixed;
    bottom: 30px;
    left: 50%;
    transform: translateX(-50%);
    background: ${background};
    color: white;
    padding: 14px 28px;
    border-radius: 12px;
    font-family: 'Noto Sans Hebrew', sans-serif;
    font-size: 16px;
    font-weight: 600;
    white-space: nowrap;
    z-index: 10000;
    box-shadow: 0px 8px 24px ${shadowColor};
    animation: toastSlideUp 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    pointer-events: none;
    min-width: 240px;
    text-align: center;
    direction: rtl;
    border: 1px solid rgba(255, 255, 255, 0.2);
  `;

  if (!document.querySelector("#toast-global-styles")) {
    const style = document.createElement("style");
    style.id = "toast-global-styles";
    style.textContent = `
      @keyframes toastSlideUp {
        from {
          opacity: 0;
          transform: translateX(-50%) translateY(40px) scale(0.9);
        }
        to {
          opacity: 1;
          transform: translateX(-50%) translateY(0) scale(1);
        }
      }
    `;
    document.head.appendChild(style);
  }

  document.body.appendChild(toastElement);

  setTimeout(() => {
    toastElement.style.transition = "opacity 0.4s ease, transform 0.4s ease";
    toastElement.style.opacity = "0";
    toastElement.style.transform = "translateX(-50%) translateY(20px) scale(0.95)";
    
    setTimeout(() => {
      if (toastElement.parentNode) {
        toastElement.parentNode.removeChild(toastElement);
      }
    }, 400);
  }, 3500);
};
